import { axiosInstance } from '@repo/api/api-client';
import { AxiosInterceptorManager } from '@repo/api/api-interceptor-manager';
import { AxiosError, AxiosResponse } from 'axios';

function callbackSessionExpired() {
  window.dispatchEvent(new CustomEvent('auth:sessionExpired'));
}

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => AxiosInterceptorManager.getInstance(callbackSessionExpired).successResponseInterceptor(response),
  (error: AxiosError) => AxiosInterceptorManager.getInstance(callbackSessionExpired).errorResponseInterceptor(error)
);
